import { requiredParam } from 'sdc-utilities';

export default (function (_ref) {
  var _ref$backend = _ref.backend,
      backend = _ref$backend === undefined ? requiredParam('backend') : _ref$backend;

  var baseUrl = 'entries';

  return {
    assign: function assign(entry, field, target, targets) {
      return function () {
        return backend.put(baseUrl + '/assign', {
          source: entry.id,
          field: field,
          target: target,
          targets: targets
        });
      };
    },
    create: function create(type) {
      return function () {
        return backend.post(baseUrl, type);
      };
    },
    update: function update(entry) {
      return function () {
        return backend.put(baseUrl, entry);
      };
    },
    remove: function remove(entry) {
      return function () {
        return backend.delete(baseUrl + '/' + entry.id);
      };
    },
    load: function load(entry) {
      return function () {
        return backend.get(cmsBase + 'entry/' + entry.id);
      };
    },
    list: function list(typeID) {
      return function () {
        return backend.get(baseUrl + '/' + typeID);
      };
    }
    //export const reload = ()         => () => axios.get(baseUrl+'/selected')
  };
});